import { ZodError } from "zod";

const ERROR_MESSAGES: Record<string, string> = {
  PDF_TOO_LARGE: "Die PDF-Datei darf höchstens 25 MB groß sein.",
  CSV_TOO_LARGE: "Die CSV-Datei darf höchstens 3 MB groß sein.",
  TEXT_TOO_LONG: "Der extrahierte Text ist zu groß (höchstens 2 Millionen Zeichen).",
  INVALID_TEXT: "Der Text konnte nicht verarbeitet werden.",
  NO_TRANSACTIONS: "Es wurden keine Buchungen gefunden.",
  TOO_MANY_TRANSACTIONS: "Es sind höchstens 5.000 Buchungen erlaubt.",
  CSV_EMPTY: "Die CSV-Datei enthält keine Buchungen.",
  CSV_HEADERS:
    "Die CSV-Datei muss die Spalten booking_date, value_date, text und amount enthalten.",
  CSV_INVALID:
    "Die CSV-Datei enthält ungültige Daten (Datum, Betrag oder Text prüfen).",
  PDF_PASSWORD: "Die PDF-Datei ist passwortgeschützt und kann nicht gelesen werden.",
  PDF_UNSUPPORTED: "Diese PDF-Datei wird nicht unterstützt oder ist beschädigt.",
  PDF_FAILED: "Die PDF-Datei konnte nicht gelesen werden.",
  PROJECTION_TOO_LONG: "Der Hochrechnungszeitraum darf höchstens 30 Jahre betragen.",
  PROJECTION_BEFORE_START:
    "Das Ende der Hochrechnung darf nicht vor der ersten Buchung liegen.",
  INVALID_DATE: "Bitte ein gültiges Datum im Format JJJJ-MM-TT eingeben.",
  INVALID_PARAMS: "Bitte prüfen Sie die eingegebenen Parameter.",
  CALC_FAILED: "Die Hochrechnung ist fehlgeschlagen.",
};

const WARNING_MESSAGES: Record<string, string> = {
  "is after the projection end":
    "Das Datum der Einmalzahlung liegt nach dem Ende der Hochrechnung; der Betrag wird nicht berücksichtigt.",
  "is before the first transaction":
    "Das Datum der Einmalzahlung liegt vor der ersten Buchung; der Betrag wird nicht berücksichtigt.",
};

export function toGermanError(error: unknown): string {
  if (error instanceof ZodError) {
    const messages = error.issues.map((issue) => issue.message);
    if (messages.some((m) => m.includes("30 years"))) {
      return ERROR_MESSAGES.PROJECTION_TOO_LONG;
    }
    if (messages.some((m) => m.includes("before the first"))) {
      return ERROR_MESSAGES.PROJECTION_BEFORE_START;
    }
    if (messages.some((m) => m.includes("calendar date") || m.includes("YYYY-MM-DD"))) {
      return ERROR_MESSAGES.INVALID_DATE;
    }
    return ERROR_MESSAGES.INVALID_PARAMS;
  }

  if (error instanceof Error) {
    const code = error.message;
    if (ERROR_MESSAGES[code]) return ERROR_MESSAGES[code];

    const lower = code.toLowerCase();
    if (lower.includes("password") || lower.includes("encrypted")) {
      return ERROR_MESSAGES.PDF_PASSWORD;
    }
    if (lower.includes("invalid pdf") || lower.includes("missing pdf")) {
      return ERROR_MESSAGES.PDF_UNSUPPORTED;
    }
    if (code === "No transactions found in text") {
      return ERROR_MESSAGES.NO_TRANSACTIONS;
    }
    if (code === "Projection produced no rows") {
      return ERROR_MESSAGES.CALC_FAILED;
    }
    return code;
  }

  return ERROR_MESSAGES.CALC_FAILED;
}

export function toGermanWarning(warning: string): string {
  for (const [needle, german] of Object.entries(WARNING_MESSAGES)) {
    if (warning.includes(needle)) return german;
  }
  return warning;
}

export { ERROR_MESSAGES };
